import React from 'react'
import type { ReactNode } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import type { HelmetServerState } from 'react-helmet-async'
import type { DocumentHeadRequestContext } from './types'

interface DocumentHeadProviderProps {
  children: ReactNode
  requestContext?: DocumentHeadRequestContext
}

/**
 * Owns the current head renderer's request scope. Browser callers omit the
 * context; SSR passes a fresh opaque context for each request.
 */
export default function DocumentHeadProvider ({
  children,
  requestContext,
}: DocumentHeadProviderProps) {
  const context = requestContext as { helmet?: HelmetServerState } | undefined
  return (
    <HelmetProvider context={context}>
      {children}
    </HelmetProvider>
  )
}
